import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import Address from '@components/address';

const ShippingAddress = () => {
    return (
        <div className={styles.wrapper}>
            <Typography variant="body1" className={styles.description}>
                Please confirm your shipping address
            </Typography>
            <Address label="shipping_address" name="shipping_address" />
        </div>
    );
};

export default ShippingAddress;
